export class RouteConstants {
  public static routeHome = '';
  public static routeDashboard = 'dashboard';
  public static routeRule: string = 'rule';
  public static routeDevice = 'device';
  public static routeDeviceGroup = 'device-group';
  public static routeCistern = 'cistern';
  public static routePump = 'pump';
  public static routeStatistics: string = 'statistics';
  public static routeWeather: string = 'weather';
  public static routeCamera: string = 'camera';
  public static routeMap: string = 'map';
  public static actionLog: string = 'action-log';
  public static routeNotifications: string = 'notifications';
  public static routeOrganization: string = 'organization';
  public static routeSettings: string = 'settings';
  public static routeProfile: string = 'profil';
  public static routeDiscover: string = 'discover';
  public static routeHelp: string = 'help';

  public static routeDemo: string = 'demo';
  public static routeDemoLogin: string = 'login/:scenarioId';

  public static routeImprint: string = 'imprint';
  public static routePrivacy: string = 'privacy';
  public static routeTerms: string = 'terms';

  public static routeError403: string = '403';
  public static routeError404: string = '404';

  public static routeAdd: string = 'add';
  public static routeUpdate: string = 'update';

  public static routeId = ':id';
}
